module.exports = __webpack_public_path__ + "img/img16.9e9c4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img16.png
// module id = 171
// module chunks = 0